import request from '@/utils/request';
import type { AxiosPromise } from 'axios';
import type { roleQuery } from '@/api/brand/type';

/** 当前登录用户修改密码的请求参数。 */
export interface UpdateUserPwdReq {
  oldPassword: string;
  newPassword: string;
}

/** 品牌用户接口中通用的详情和批量操作参数。 */
interface BrandUserQuery extends roleQuery {
  id?: string | number;
  ids?: Array<string | number>;
}

/** 当前用户关联的数据范围。 */
export interface BrandUserRelation {
  id?: string | number;
  type?: string;
  typeId?: string | number;
  relationName?: string;
  relationList?: BrandUserRelation[];
}

/** 当前登录品牌用户信息。 */
export interface BrandUserInfo {
  avatar: string | null;
  userName: string;
  nickName: string;
  userId: string | number;
  tenantId: string;
  tenantName?: string;
  phonenumber?: string;
  email?: string;
  deptName?: string;
  deptId?: string | number;
  shopId?: string | number;
  staffType?: string;
  currentRelation?: BrandUserRelation;
  relations?: BrandUserRelation[];
}

/** 当前登录用户接口的业务数据。 */
export interface BrandUserInfoData {
  user: BrandUserInfo;
  permissions?: string[];
  menuPermission?: string[];
}

/** 默认密码检查接口响应。 */
export interface DefaultPasswordCheckResponse {
  code?: number;
  msg?: string;
  data: boolean;
}

/** 当前登录用户接口响应。 */
export interface BrandUserInfoResponse {
  code?: number;
  msg?: string;
  data: BrandUserInfoData;
}

/**
 *员工
 * @param query
 * @returns {*}
 */
// 分页查询品牌员工列表
export const UserList = (query?: roleQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/user/list',
    method: 'post',
    headers: { repeatSubmit: false },
    params: { pageNum: query.pageNum, pageSize: query.pageSize },
    data: query,
  });
};
// 分页查询门店员工列表
export const shopUserList = (query?: roleQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/user/shopUserList',
    method: 'post',
    headers: { repeatSubmit: false },
    params: { pageNum: query.pageNum, pageSize: query.pageSize },
    data: query,
  });
};

// 新增员工
export const addUser = (query?: roleQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/user/add',
    method: 'post',
    data: query,
  });
};
// 编辑员工
export const editUser = (query?: roleQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/user/edit',
    method: 'post',
    data: query,
  });
};
// 获取详情
export const getUserDetails = (query?: BrandUserQuery): AxiosPromise<[]> => {
  return request({
    url: `/b/brand/user/${query.id}`,
    method: 'get',
  });
};

// 删除
export const delUser = (query?: BrandUserQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/user/remove',
    method: 'post',
    data: query.ids,
  });
};
// 启用禁用员工
export const updateStatus = (query?: roleQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/user/updateStatus',
    method: 'put',
    data: query,
  });
};
// 变更部门
export const updateDept = (query?: roleQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/user/updateDept',
    method: 'put',
    data: query,
  });
};
// 分页查询品牌员工列表
export const listByRoleList = (query?: roleQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/user/listByRole',
    method: 'get',
    params: query,
  });
};
//
// 查询不同状态员工数量
export const getCountByStatus = (query?: roleQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/user/getCountByStatus',
    method: 'post',
    headers: { repeatSubmit: false },
    data: query,
  });
};
// 员工及角色总数量
export const getUserAndRoleCount = (query?: roleQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/user/getUserAndRoleCount',
    method: 'post',
    headers: { repeatSubmit: false },
    data: query,
  });
};
// 修改当前登录用户密码
export const updateUserPwdApi = (data: UpdateUserPwdReq): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/user/updateUserPwd',
    method: 'post',
    data,
  });
};
// 批量授权品牌员工角色及数据权限范围
export const batchAuth = (query?: roleQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/user/batchAuth',
    method: 'post',
    data: query,
  });
};
// 新增门店员工
export const addShopUserh = (query?: roleQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/user/addShopUser',
    method: 'post',
    data: query,
  });
};
// 编辑门店员工
export const editShopUser = (query?: roleQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/user/editShopUser',
    method: 'post',
    data: query,
  });
};
// 编辑门店员工
export const removeShopUser = (query?: BrandUserQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/user/removeShopUser',
    method: 'post',
    data: query.ids,
  });
};
// 获取门店管理员账号数量
export const getShopAdminUserCount = (query?: roleQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/user/getShopAdminUserCount',
    method: 'get',
    params: query,
  });
};
// 变更门店管理员
export const changeShopAdminApi = (data?: roleQuery): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/user/changeShopAdmin',
    method: 'post',
    data,
  });
};
// 获取用户信息
export const getInfoApi = (): Promise<BrandUserInfoResponse> => {
  return request<BrandUserInfoResponse, BrandUserInfoResponse>({
    url: '/b/brand/user/getInfo',
    method: 'get',
    headers: { hideErrorNotification: true },
  });
};
// 检查当前登录用户是否仍使用默认密码
export const checkDefaultPasswordApi = (): Promise<DefaultPasswordCheckResponse> => {
  return request<DefaultPasswordCheckResponse, DefaultPasswordCheckResponse>({
    url: '/b/brand/user/password/checkDefault',
    method: 'get',
    headers: { hideErrorNotification: true },
  });
};
// 下载品牌员工导入模板
export const downBrandUserTemplateApi = (): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/user/downBrandUserTemplate',
    method: 'get',
  });
};
// 品牌员工导入数据校验
export const preCheckBrandUserApi = (data): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/user/preCheckBrandUser',
    method: 'post',
    data,
  });
};
// 品牌员工导入
export const importBrandUserApi = (data): AxiosPromise<[]> => {
  return request({
    url: '/b/brand/user/importBrandUser',
    method: 'post',
    data,
  });
};
